import { SVGPropsIcon } from 'src/types';

export const GamesIcon = (props: SVGPropsIcon) => (
  <svg
    width="25"
    height="24"
    viewBox="0 0 25 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}>
    <path
      d="M12.3882 19.5192C11.3392 20.4409 9.96356 20.9999 8.45741 20.9999C5.16722 20.9999 2.5 18.3326 2.5 15.0425C2.5 11.7523 5.16722 9.08506 8.45741 9.08506C9.93798 9.08506 11.3461 9.67148 12.3882 10.5654M8.73197 10.6128C8.73197 10.6128 8.73197 5.57143 16.3184 3M15.8796 10.6126C15.8796 10.6126 12.2929 8.49234 14.3286 4.02857M22.2758 15.0426C22.2758 18.3328 19.6086 21 16.3184 21C13.0282 21 10.361 18.3328 10.361 15.0426C10.361 11.7524 13.0282 9.08519 16.3184 9.08519C19.6086 9.08519 22.2758 11.7524 22.2758 15.0426Z"
      stroke="#EDD2FC"
      strokeWidth="1.11086"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
